module.exports = __webpack_public_path__ + "img/img-4.55864927.png";